import { EVENT_SLIDER_READY } from '@kissui/components'
import viewportHelper from '@kissui/helpers/src/viewport.helpers'
import zoneTracking from '@kissui/helpers/src/assets/js/zoneTracking'
import createProps from '@kissui/helpers/src/props.helpers'
import createRefs from '@kissui/helpers/src/refs.helpers'
import { readEvent } from '@kissui/helpers/src/assets/js/eventDispatch'
import { handlePromoClick } from '@kissui/helpers/src/gtmEvents'
import '@kissui/components/src/slider-menu'

class NavigationBar extends HTMLElement {
    constructor() {
        super()
        this.boundOnSliderReady = this.onSliderReady.bind(this)
        this.boundOnNavigationClick = this.onNavigationClick.bind(this)
    }

    connectedCallback() {
        this.props = createProps(this.attributes)
        this.disableAutoScroll = this.getAttribute('disable-auto-scroll') || this.disableAutoScroll

        this.render()
        this.refs = createRefs(this)
        this.bindEvent()
        this.initTracking()
    }

    bindEvent() {
        if (!this.refs.navLink) {
            return
        }

        this.refs.navLink.addEventListener(EVENT_SLIDER_READY, this.boundOnSliderReady, {
            once: true
        })
    }

    unbindEvent() {
        if (!this.refs.navLink) {
            return
        }

        this.refs.navLink.removeEventListener(EVENT_SLIDER_READY, this.boundOnSliderReady, {
            once: true
        })

        this.refs.navLink.querySelectorAll('a').forEach(link => {
            link.removeEventListener('click', this.boundOnNavigationClick)
        })
    }

    initTracking() {
        const { campaign } = this.props
        if (!campaign) {
            return
        }

        zoneTracking(this, campaign)
    }

    render() {
        const { copywriting } = this.props
        const { a11y_slider_previous_button, a11y_slider_next_button } = copywriting
        const slot = this.innerHTML
        this.innerHTML = `
                    <div contrast="light">
                        <div class="cb-navigation-bar">
                        <nav class="cb-navigation-bar--links_list">
                            <nb-slider-menu
                                a11y_slider_previous_button="${a11y_slider_previous_button}"
                                a11y_slider_next_button="${a11y_slider_next_button}"
                                navigation="${!viewportHelper.is.mobile}"
                                disable_auto_scroll="${this.disableAutoScroll}"
                                data-ref="navLink">
                                    ${this.renderLinksList()}
                                    ${slot}
                            </nb-slider-menu>
                        </nav>
                    </div>
                </div>`
    }

    onSliderReady(e) {
        const event = readEvent(e)
        const { className } = event
        const { campaign } = this.props

        if (!campaign || !this.refs.navLink || !this.refs.navLink.querySelector(`.${className}`)) {
            return
        }

        this.refs.navLink.querySelectorAll('a').forEach((link, ind) => {
            link.setAttribute('data-index', ind + 1)
            link.addEventListener('click', this.boundOnNavigationClick)
        })
    }

    onNavigationClick(e) {
        const { campaign } = this.props
        const label = e.currentTarget.getAttribute('phantom')
        const index = e.currentTarget.getAttribute('data-index')
        handlePromoClick({ campaign, cta_name: `NAVIGATION LINKS - ${index} - ${label}` })
    }

    renderLinksList() {
        const { navigation = [] } = this.props
        return navigation.map(link => this.renderLink(link)).join('')
    }

    renderLink({
        link = '',
        icon_left = '',
        image = '',
        image_alt = '',
        seo_label = '',
        label = '',
        selected = false
    }) {
        return `
        <nb-link
            link="${this.props['id-links-auto'] ? '#' + label : link}"
            phantom="true"
            color="black"
            selected=${selected}
            ${seo_label && `seo_label="${seo_label}"`}
            ${image && `image="${image}"`}
            ${image_alt && `image_alt="${image_alt}"`}
            ${icon_left && `icon_left="${icon_left}"`}>${label}</nb-link>`
    }

    disconnectedCallback() {
        this.unbindEvent()
    }
}

customElements.get('nb-navigation-bar') || customElements.define('nb-navigation-bar', NavigationBar)

export default NavigationBar
